module.exports = __webpack_public_path__ + "img/drawCount.7b306a26.png";